module.exports = __webpack_public_path__ + "img/no-image.e23d921d.jpg";